import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import TvFilledIcon from '../../../../components/Icons/TvFilledIcon';

const ClientIcon = () => <TvFilledIcon className='w-[16px] text-[#1B4332] mr-[4px]' />;

const ClientSelect = forwardRef(
  ({ value: propValue, onChange, placeholder, labelId, error, helperText, ...props }, ref) => {
    const value = Array.isArray(propValue) ? propValue[0] : propValue;
    return (
      <Autocomplete
        {...props}
        fullWidth
        value={value}
        aria-labelledby={labelId}
        onChange={(_, data) => onChange(data)}
        getOptionLabel={option => option?.label || ''}
        ref={ref}
        disableClearable
        isOptionEqualToValue={(option, selectValue) => selectValue && option.value === selectValue?.value}
        renderInput={params => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            variant='outlined'
            slotProps={{
              input: {
                ...params.InputProps,
                startAdornment: value ? <ClientIcon /> : null,
              },

              htmlInput: {
                ...params.inputProps,
                placeholder: placeholder,
              },
            }}
          />
        )}
        renderOption={ClientRenderer}
      />
    );
  },
);

ClientSelect.propTypes = {
  id: PropTypes.string,
  labelId: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  options: PropTypes.array,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

ClientSelect.defaultProps = {
  placeholder: 'Select Client',
  value: '',
};

const ClientRenderer = (props, option) => {
  return (
    <li {...props}>
      <ClientIcon />
      <span>{option.label}</span>
    </li>
  );
};

export default ClientSelect;
